import { graphql } from '~publish/gql'
import { useTypedMutation } from '~publish/hooks/useTypedMutation'

export const OPTIMIZE_POSTING_SCHEDULE_MUTATION = graphql(/* GraphQL */ `
  mutation OptimizePostingSchedule($input: OptimizePostingScheduleInput!) {
    optimizePostingSchedule(input: $input) {
      __typename
      ... on OptimizePostingScheduleResponse {
        postingSchedule {
          day
          times
          paused
        }
      }
      ... on MutationError {
        message
      }
    }
  }
`)

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const useOptimizePostingSchedule = () => {
  return useTypedMutation(
    OPTIMIZE_POSTING_SCHEDULE_MUTATION,
    (data) => data.optimizePostingSchedule,
    {
      successTypename: 'OptimizePostingScheduleResponse',
      refetchQueries: ['GetPostingScheduleInfo'],
    },
  )
}
